import { createContext } from 'react';
import { FormState } from 'react-hook-form';

export const DrawerContext = createContext<{
  onInnerFormChange?: (formState: FormState<any>) => void;
}>({
  onInnerFormChange: undefined
});
